import script from "./legoStepBox.vue?vue&type=script&lang=js"
export * from "./legoStepBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/lego-component/components/boxes/legoStepBox/legoStepBox.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5fb82fda"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5fb82fda', __exports__)) {
    api.reload('5fb82fda', __exports__)
  }
  
}


export default __exports__